import Highway from '@dogstudio/highway';
import Default from './transitions/Default';
import Home from './routes/home';
import Gallery from './routes/gallery';
import Studio from './routes/studio';
import Contact from './routes/contact';
import { readGlobalState, setGlobalState } from './util/helpers';

export const H = new Highway.Core({
  transitions: {
    default: Default,
  },
  renderers: {
    home: Home,
    gallery: Gallery,
    studio: Studio,
    contact: Contact,
  },
});

// On route change
H.on('NAVIGATE_IN', ({ to }) => {
  updateBodyClasses(to);
});

// On route transition end
H.on('NAVIGATE_END', () => {
  setGlobalState('isTransitioning', false);
});

const updateBodyClasses = (to) => {
  const classElement = to.page.querySelector('[data-router-content]');
  document.body.classList = classElement.classList;

  if (readGlobalState('navigationOpen')) {
    document.body.classList.add('navigation-open');
  }
}